import { z } from 'zod';

import { Current } from '../fields/Current';
import { Capacitance } from '../fields/Capacitance';
import { Resistance } from '../fields/Resistance';
import { Frequency } from '../fields/Frequency';
import { Power } from '../fields/Power';
import { PowerFactor } from '../fields/PowerFactor';
import { Voltage } from '../fields/Voltage';

import { ACPortConfiguration } from './AbstractPort.ACPortConfiguration';
import { DCPortConfiguration } from './AbstractPort.DCPortConfiguration';
import { PowerFlowDirection } from './AbstractPort.PowerFlowDirection';
import { PortControlMethods } from './AbstractPort.ControlMethods';
import { Terminal } from './Terminal';
import { PortFeatures } from './AbstractPort.Features';
import { PortIsolated } from './AbstractPort.Isolated';
import { WireSizeRange } from './WireSizeRange';
import { ACEarthingConfigurations } from './AbstractPort.ACEarthingConfigurations';
import { DCEarthingConfigurations } from './AbstractPort.DCEarthingConfigurations';
import { ParallelableCapacity } from './ParallelableCapacity';

const DCPort = z.object({
    enabled: z.boolean().default(true),
    voltage: Voltage.validator,
    current: Current.validator,
    power: Power.validator,
    configuration: DCPortConfiguration.validator,
    earthingConfigurations: DCEarthingConfigurations.validator,
});

const ACPort = z.object({
    enabled: z.boolean().default(true),
    voltage: Voltage.validator,
    current: Current.validator,
    power: Power.validator,
    frequency: Frequency.validator,
    powerFactor: PowerFactor.validator,
    configuration: ACPortConfiguration.validator,
    earthingConfigurations: ACEarthingConfigurations.validator,
});

export const AbstractPort = z.object({
    id: z.string().optional(),
    label: z.string().optional(),
    features: PortFeatures.validator,
    powerFlowDirection: PowerFlowDirection.validator,
    terminal: Terminal.validator,
    wireSize: WireSizeRange.validator,
});

export const Port = {
    AC: ACPort,
    DC: DCPort,
    capacitance: Capacitance,
    equivalentSeriesResistance: Resistance,
    controlMethods: PortControlMethods,
    isolated: PortIsolated,
    parallelableCapacity: ParallelableCapacity,
    powerFlowDirection: PowerFlowDirection,
};
